<div class="reward-card" [style.background]="rule.theme_color | themeBackground">
  <div class="card-content">
    <div class="card-header">
      <h3 class="card-title">{{ title }}</h3>
    </div>

    <div class="progress-section" *ngIf="hasProgress">
      <div class="progress-bar">
        <div class="progress-track">
          <div class="progress-fill" [style.width.%]="progressPercent"></div>
        </div>
        <div class="progress-text">
          <span class="current">{{ progressCurrent }}</span>
          <span class="separator">/</span>
          <span class="total">{{ rule.items_sold }}</span>
        </div>
      </div>
    </div>

    <div class="card-footer">
      <div class="trophy-badge">
        <img src="/assets/images/rewards/white-trophy.svg" alt="Trophy">
        <span class="won-today">{{ wonTodayLabel }}</span>
      </div>
    </div>
  </div>
  <div class="card-image">
    <img [src]="illustrationSrc" [alt]="rule.name" class="illustration">
  </div>
</div>
